import { ElementRef } from '@angular/core';

export abstract class ItmAbstractElementRef {

	constructor(
		private element: ElementRef
	) { }

	public getElementRef() {
		return this.element;
	}

}
